import React, { Component } from 'react'

export default (ComponentToRender, { delay }) => {
  return class extends Component {
    state = {
      loaded: false
    }

    shouldComponentUpdate (nextProps, nextState) {
      if (!this.state.loaded && nextState.loaded) {
        return true
      }
      if (!nextProps.active) {
        return false
      }
      if (!nextState.loaded) {
        return false
      }
      return true
    }

    componentDidMount () {
      if (!this.state.loaded && !this.props.active) {
        this.loadAfterDelay()
      } else if (!this.state.loaded && this.props.active) {
        this.loadImmediately()
      }
    }

    loadAfterDelay = () => {
      setTimeout(() => {
        this.setState({ loaded: true })
      }, delay)
    }

    loadImmediately = () => {
      this.setState({ loaded: true })
    }

    render () {
      return <ComponentToRender {...this.props} loaded={this.state.loaded} />
    }
  }
}
